import { render, staticRenderFns } from "./ChartBotPlayer.vue?vue&type=template&id=22639d70&scoped=true&"
import script from "./ChartBotPlayer.vue?vue&type=script&lang=js&"
export * from "./ChartBotPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChartBotPlayer.vue?vue&type=style&index=0&id=22639d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22639d70",
  null
  
)

export default component.exports